import { Single } from './Single';

const SharerPage = {
  Single
};


export default SharerPage;